var poll_default = {
  "fontElementMap": "_7il2N",
  "container": "R9KjP",
  "fullscreen": "_9E79f",
  "background_overlay": "yscVO",
  "with_image": "KUSXc",
  "options": "kfGdl",
  "webview": "AAbud",
  "grid": "r6AbZ",
  "option": "_56qrQ",
  "cta_button": "k-YZq",
  "add_option": "TLJbI",
  "see_more": "YToey",
  "list": "uQS5H",
  "column": "lSG1j",
  "additional_note": "dmggz",
  "spinner": "_1Fy62",
  "spin": "zEL7S",
  "shown": "_0iRYf",
  "error": "T-HeK"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
